import type { JSX, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../../hooks/useApp';
import { canAccess } from '../../lib/roles';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element | null {
  const { role } = useApp();
  const location = useLocation();

  // Still loading profile — show nothing (auth guard handles the loading UI)
  if (!role) return null;

  if (!canAccess(role, location.pathname)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
